import React, { useEffect, useState } from 'react';
import { Drawer, notification, Spin, message } from 'antd';
import { isMobile } from 'react-device-detect';
import api from 'utils/api';
import InvoiceStore from 'stores/InvoiceStore';

import FileDownload from 'js-file-download';

interface IProps {
    invoiceId: number;
    onClose: () => void;
}

const InvoicePreview: React.FC<IProps> = ({ invoiceId, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [fileURL, setFileURL] = useState();

    useEffect(() => {
        setLoading(true);

        async function getPreview() {
            try {
                const response = await InvoiceStore.invoicePreview(invoiceId);

                if (isMobile) {
                    FileDownload(response, `Invoice-${invoiceId}.pdf`);
                    onClose();
                    notification.success({ message: 'Document downloaded' });
                } else {
                    const file = new Blob([response], { type: 'application/pdf' });

                    const fileURL: any = URL.createObjectURL(file);

                    setLoading(false);
                    setFileURL(fileURL);
                }
            } catch (err: any) {
                message.error(err);
            }
        }

        getPreview();
    }, [invoiceId]);

    return (
        <Drawer title="Preview" width={'80%'} closable open placement={'left'} onClose={onClose}>
            <Spin spinning={loading}>
                <iframe
                    title={'Sales Order Preview'}
                    src={fileURL}
                    frameBorder="0"
                    height={window.innerHeight}
                    width="100%"
                />
            </Spin>
        </Drawer>
    );
};

export default InvoicePreview;
